export default __webpack_public_path__ + "static/220209_U22_Sizzle_DB-8496cc358d1107f86495651cb5557ec6.mp4";